export default {
	methods: {
		onContextmenu(event) {
			event.preventDefault()
		}
	},
	mounted() {
		this.$el.addEventListener('contextmenu', this.onContextmenu)
	},
	beforeDestroy() {
		this.$el.removeEventListener('contextmenu', this.onContextmenu)
	}
}
